import React from 'react';
import { Database, Loader2, ShieldCheck } from 'lucide-react';


function AtomicSubmissionProgress({ total }) {
  return (
    <section className="rounded-2xl border-2 border-slate-200 bg-white p-6 text-center sm:p-8">
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-brand-gold to-brand-primary">
        <Loader2 className="h-8 w-8 animate-spin text-white" />
      </div>
      <h2 className="font-montserrat text-2xl font-extrabold text-brand-primary">
        Creando lote de provincia
      </h2>
      <p className="mt-2 font-montserrat text-sm text-slate-600">
        El servidor está validando y creando {total} entrega{total !== 1 ? 's' : ''} en una sola transacción.
      </p>

      <div className="mx-auto mt-7 max-w-lg">
        <div className="h-3 overflow-hidden rounded-full bg-slate-200" role="progressbar" aria-label="Procesando lote atómico" aria-valuetext="Procesando">
          <div className="h-full w-1/3 animate-pulse rounded-full bg-gradient-to-r from-brand-gold via-brand-primary to-brand-green" />
        </div>
        <p className="mt-2 font-montserrat text-xs text-slate-500">
          Progreso indeterminado: no se confirmará ninguna fila hasta completar todo el lote.
        </p>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-3 text-left sm:grid-cols-2">
        <div className="flex items-center gap-3 rounded-xl bg-slate-50 p-4">
          <Database className="h-5 w-5 text-brand-primary" />
          <span className="font-montserrat text-sm text-slate-700">Validación final e inventario</span>
        </div>
        <div className="flex items-center gap-3 rounded-xl bg-brand-green/10 p-4">
          <ShieldCheck className="h-5 w-5 text-brand-green" />
          <span className="font-montserrat text-sm text-slate-700">Creación atómica, sin resultados parciales</span>
        </div>
      </div>
    </section>
  );
}

export default AtomicSubmissionProgress;
